import { graphql } from 'src/graphql';

export const NotificationsByTeamSubscription = graphql(`
  subscription NotificationsByTeam($_team_id: ID!) {
    notificationsByTeam(_team_id: $_team_id) {
      _id
      message
      link
      type
      subtype
      read
      created
      context {
        booking {
          _id
          name
          type
          config {
            timezone
            online_task {
              type
            }
            session {
              type
            }
          }
        }
        booking_participant {
          _id
          cancel_reason
          feedback {
            participant
          }
        }
        participant_session {
          _id
          start
          end
        }
        messages {
          _id
          body
        }
      }
    }
  }
`);
